import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { ParticleBackground } from './ParticleBackground';

export default function Layout({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      {/* 全站动态粒子背景（fixed z-0），所有页面共享。
          内容包在 relative z-10 容器里，确保渲染在画布之上。 */}
      <ParticleBackground />
      <div className="relative z-10 flex flex-col flex-1">
        <Navbar />
        <main className="flex-1">
          {children || <Outlet />}
        </main>
        <Footer />
      </div>
    </div>
  );
}
